export class RegisterFCMTokenRequestDTO{
    token !: string;
    deviceInfo !: string;

    constructor(data: RegisterFCMTokenRequestDTO){
        Object.assign(this, data);
    }
}